<div class="d-flex">
    <button class="share_Icon" (click)="shareFile(element)">
        <img src="assets/images/share.svg" alt="">
    </button>
    <div class="more_horiz" *ngIf="pageName != 'groups'">
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <a mat-menu-item target="_blank" (click)="docViewDetail(element)">
                <mat-icon>visibility</mat-icon>View
            </a>
            <a [href]="element?.documentPathDMS" target="_blank" mat-menu-item [download]="element?.documentPathDMS">
                <mat-icon>cloud_download</mat-icon>Download
            </a>
            <button (click)="editDoc('editFileDocument', element)" mat-menu-item>
                <mat-icon>edit</mat-icon>Edit
            </button>
            <button mat-menu-item (click)="editDoc('uploadNewVersion', element)">
                <mat-icon>history</mat-icon>Upload New Version
            </button>
            <button (click)="deleteDoc(element)" mat-menu-item class="text-danger" *ngIf="pageName != 'share'">
                <mat-icon class="text-danger">delete_outline</mat-icon> Delete
            </button>
        </mat-menu>
    </div>
</div>